import { render, staticRenderFns } from "./applicant-info.vue?vue&type=template&id=1f345e5f&"
import script from "./applicant-info.vue?vue&type=script&lang=js&"
export * from "./applicant-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports